import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=04fb3af2&"
import script from "./GlobalMenu.vue?vue&type=script&lang=ts&"
export * from "./GlobalMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports